var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledMusclesBlazedOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "v3etam1qda",
    d: "M0 0L19.973 0 19.973 20.459 0 20.459z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-251 -535) translate(251 535)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9yte41xb5b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v3etam1qda"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F60",
    d: "M19.495 18.298c-.034-.344-.011-.692-.014-1.039-.014-1.842-.027-3.684-.048-5.526-.002-.145.105-.418-.239-.331-.846.213-1.483-.152-2.094-.678-1.521-1.31-3.31-1.832-5.302-1.612-1.77.196-3.26 1.053-4.666 2.068-.314.225-.613.47-.918.706l-.077-.052c.05-.196.098-.393.149-.588.3-1.17.229-2.365.26-3.554.017-.68.086-1.352.43-1.969.173-.308.373-.443.746-.356.67.157 1.352.241 2.044.19.773-.058 1.13-.379 1.235-1.14.02-.146.089-.188.203-.214.773-.172 1.09-1.133.693-1.87-.316-.586-.65-1.164-.996-1.735-.279-.461-.711-.651-1.25-.585-.237.028-.474.063-.704.12-1.93.48-3.458 1.596-4.66 3.105C2.955 4.91 2.148 6.878 1.51 8.89c-.613 1.935-.862 3.95-.998 5.968-.098 1.44.478 2.291 1.824 2.86.648.272 1.326.446 2.02.554 1.805.282 5.313 1.164 7.133 1.22 3.07.093 4.458-.716 7.53-.73.358 0 .514-.086.477-.465",
    mask: "url(#9yte41xb5b)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledMusclesBlazedOrange);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-muscles--blazed-orange.86196709a097032b36caaf582a2a489c.svg";
export { ForwardRef as ReactComponent };